const { default: axiosIns } = require('@/libs/axios')

const AdGroupsService = {
  // GET - AdGroupApiController
  async get(id, campaignId, accountId) {
    return axiosIns
      .get(`/adgroups/${id}?accountId=${accountId}&campaignId=${campaignId}`)
      .then(response => response.data)
  },
  async getAdGroupCampaign(adGroup, accountId) {
    return axiosIns.get(`adgroups/${adGroup.id}/campaign?accountID=${accountId}`).then(response => response.data)
  },
  // POST - AdGroupApiController
  async create(adGroup, accountId) {
    return axiosIns.post(`/adgroups?accountId=${accountId}`, adGroup).then(response => response.data)
  },
  async duplicateAdGroup(adGroup, accountId) {
    return axiosIns.post(`/adgroups/${adGroup.adGroupId}?accountId=${accountId}`, adGroup).then(response => response.data)
  },
}

export default AdGroupsService
